export default "__VITE_ASSET__COx7VVhC__"